import React from 'react';

import { StyledButton } from './button.style';

const Button = (props) => {
  const {
    children,
    sizevalue = 'normal',
    color = 'primary',
    varient = 'gradient',
    weight = '500',
    round = 'true',
    focused = false,
    className = '',
    type = 'button',
    buttonMinWidth,
    loading = false,
    ...otherProps
  } = props;

  const focusedStyle = focused ? 'focused' : '';

  return (
    <>
      <StyledButton
        className={`${className} btn-wrapper ${focusedStyle}`}
        type={type}
        weight={weight}
        color={color}
        sizevalue={sizevalue}
        varient={varient}
        round={round}
        buttonMinWidth={buttonMinWidth}
        {...otherProps}
      >
        {loading && <span className="spinner" style={{ marginRight: '8px' }}></span>}
        {children}
      </StyledButton>
    </>
  );
};
export default Button;
